import store from '@/store';
import { apiURL } from './api_helper';

// Transport for the AI lesson wizard's analytics batches.
//
// Deliberately NOT fetchData/axios, for two reasons:
//  * fetchData routes every failure through globalErrorHandler, which can closeModal(),
//    showGlobalToast() and even location.replace('/classes'). A fire-and-forget
//    telemetry POST must never be able to do any of that to a teacher mid-wizard.
//  * the beforeunload flush needs `keepalive`, which XHR — and therefore axios — cannot
//    do. (navigator.sendBeacon is not a substitute: it cannot set x-api-key.)
//
// The header set is the minimum fetchData's default branch would have produced.
const EVENTS_URL = `${apiURL}/api/ai-lessons/events`;

export default function sendAiLessonEvents(events, keepalive) {
  try {
    if (!events || !events.length) return;
    // jsdom (unit tests) has no fetch; absence of a transport target is a no-op, not
    // an error.
    if (typeof fetch !== 'function') return;
    const headers = {
      'Content-Type': 'application/json',
      'x-api-key': store.state.authToken || '',
      platform: 'web'
    };
    // Taken off the batch rather than read live, so a flush that races a wizard restart
    // is still attributed to the run the events actually belong to.
    if (events[0] && events[0].wizardRunId) headers['x-ai-wizard-run'] = events[0].wizardRunId;
    const p = fetch(EVENTS_URL, {
      method: 'POST',
      headers,
      body: JSON.stringify({ events }),
      keepalive: !!keepalive
    });
    // The endpoint always answers 204 and we ignore the body either way; swallow the
    // network rejection so it cannot surface as an unhandled promise rejection.
    if (p && p.catch) p.catch(() => {});
  } catch (e) {
    // Analytics must never surface.
  }
}



// WEBPACK FOOTER //
// ./src/api/aiLessonEvents.js